import filterAccepted from './filterAccepted'
import filterExisting from './filterExisting'
import filterExistingDocuments from './filterExistingDocuments'
import findIdByName from './findIdByName'
import fromUrl from './fromUrl'
import getCount from './getCount'
import getMimeTypeFromExtension from './getMimeTypeFromExtension'
import handleDownload from './handleDownload'
import handleOpen from './handleOpen'
import handleRemove from './handleRemove'
import imageToPdf from './imageToPdf'
import toArray from './toArray'
import toFileList from './toFileList'

const file = {
  filterAccepted,
  filterExisting,
  filterExistingDocuments,
  findIdByName,
  fromUrl,
  getCount,
  getMimeTypeFromExtension,
  handleDownload,
  handleOpen,
  handleRemove,
  imageToPdf,
  toArray,
  toFileList,
}

export default file
